// Esta hoja es probable que desaparezca, no la reescribi
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import { useSelector } from 'react-redux';
import { palette } from '../../../system/styles/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    overflow: 'auto',
    minHeight: '85vh',
  },
  paper: {
    width: '90%',
    fontFamily: 'futura-pt',
    overflow: 'auto',
    height: '100%',
    padding: '20px',
    margin: '10px auto',
  },
  textSize: {
    fontSize: '1.6rem !important',
    'div > p:nth-of-type(1)': {
      fontSize: '1.6rem !important',
    },
    '& > p': {
      fontSize: '1.6rem !important',
    },
  },
  table: {
    minWidth: 750,
    fontSize: '1.6rem !important',
    padding: '20px',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  ButtonSend: {
    width: 'auto',
    padding: '7px 17px',
    backgroundColor: '#5373FC',
    color: palette.white,
    fontSize: '1.6rem',
    fontWeight: '500',
    borderRadius: '4px',
    textDecoration: 'none',
    '&:hover': {
      color: palette.white,
    },
    fontFamily: 'futura-pt',
  },
  ButtonContainer: {
    width: '100%',
    position: 'relative',
    padding: '20px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    bottom: 0,
  },
  selectArea: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    padding: 15,
  },
  selectCarrer: {
    width: '80%',
    fontSize: '1.8rem',
  },
  selectContainer: {
    width: '45%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  label: {
    fontSize: '1.4rem',
    width: '100%',
    textAlign: 'start',
  },
  buttonContainer: {
    width: '100%',
    padding: 15,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
  message: {
    margin: 10,
    fontSize: '2rem',
    textAlign: 'start',
  },
}));

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { onSelectAllClick, numSelected, rowCount, onRequestSort, classes } = props;

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'Seleccionar todos' }}
          />
        </TableCell>
        <TableCell align="left" padding="default" sortDirection={false} className={classes.textSize}>
          Nombre
        </TableCell>
        <TableCell align="left" padding="default" sortDirection={false} className={classes.textSize}>
          Correo electrónico
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

export const StudentDestiny = ({ data, sendEmail }) => {
  const classes = useStyles();
  const platform = useSelector((state) => state.platform);
  const [state, setState] = useState({
    career: '',
    campus: '',
  });
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  const filterUsers = data.filter((n) => n.status === 'authorized');
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = data.map((n) => n.email);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  const handleClick = (event, email) => {
    const selectedIndex = selected.indexOf(email);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, email);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

  const onChangeField = async (e) => {
    const {target} = e;
    const {name} = target;
    const {value} = target;
    await setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    const emails = [];
    const promise = Promise.all(
      data.map((us) => {
        const {career} = state;
        const {campus} = state;
        if (campus !== '' && career !== '') {
          if (us.campusSegment === campus && us.career === career) {
            emails.push(us.email);
          }
        } else if (campus === '' && career !== '') {
          if (us.career === career) {
            emails.push(us.email);
          }
        } else if (career === '' && campus !== '') {
          if (us.campusSegment === campus) {
            emails.push(us.email);
          }
        }
      })
    );
    promise.then(() => {
      setSelected(emails);
    });
  }, [state]);

  return (
    <div className={classes.root} style={{ backgroundColor: 'white' }}>
      <div className={classes.selectArea}>
        <div className={classes.selectContainer}>
          <label className={classes.label}>Filtrar por carrera</label>
          <select className={classes.selectCarrer} value={state.career} onChange={onChangeField} name="career">
            <option value="">Selecciona una</option>
            {platform.carrers.map((c) => {
              return (
                <option key={c} value={c}>
                  {c}
                </option>
              );
            })}
          </select>
        </div>
        <div className={classes.selectContainer}>
          <label className={classes.selectCarrer}>Filtrar por campus</label>
          <select className={classes.selectCarrer} value={state.campus} onChange={onChangeField} name="campus">
            <option value="">Selecciona una</option>
            {platform.platformCampus.map((c) => {
              return (
                <option key={c} value={c}>
                  {c}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      {state.career !== '' || state.campus !== '' ? (
        <Paper className={classes.paper} elevation={0}>
          <div className={classes.selectArea}>
            <p className={classes.message}>
              Se enviará el mail a todos los estudiantes que pertenezcan al segmento de usuarios seleccionados.
            </p>
          </div>
          <div className={classes.buttonContainer}>
            <button type="button" className={classes.ButtonSend} onClick={() => sendEmail(selected)}>
              Enviar correo
            </button>
          </div>
        </Paper>
      ) : (
        <Paper className={classes.paper} elevation={0}>
          <TableContainer>
            <Table className={classes.table} aria-labelledby="tableTitle" size="medium" aria-label="enhanced table">
              <EnhancedTableHead
                classes={classes}
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={data.length}
              />
              <TableBody>
                {stableSort(data, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const isItemSelected = isSelected(row.email);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    if (row.status === 'authorized') {
                      return (
                        <TableRow
                          hover
                          onClick={(event) => handleClick(event, row.email)}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.email}
                          selected={isItemSelected}>
                          <TableCell padding="checkbox">
                            <Checkbox checked={isItemSelected} inputProps={{ 'aria-labelledby': labelId }} />
                          </TableCell>
                          <TableCell
                            className={classes.textSize}
                            component="th"
                            id={labelId}
                            scope="row"
                            padding="none">
                            {`${row.names} ${row.lastNames}`}
                          </TableCell>
                          <TableCell
                            className={classes.textSize}
                            component="th"
                            id={labelId}
                            scope="row"
                            padding="none">
                            {`${row.email}`}
                          </TableCell>
                        </TableRow>
                      );
                    }
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            className={classes.textSize}
            rowsPerPageOptions={[5, 10, 20]}
            component="div"
            count={filterUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            labelRowsPerPage={<span style={{ fontSize: '1rem' }}>Usuarios por pagina</span>}
          />
          <div className={classes.ButtonContainer}>
            <button type="button" className={classes.ButtonSend} onClick={() => sendEmail(selected)}>
              Enviar correo
            </button>
          </div>
        </Paper>
      )}
    </div>
  );
};

export const CompanyDestiny = ({ data, sendEmail }) => {
  const classes = useStyles();
  const platform = useSelector((state) => state.platform);
  const [state, setState] = useState({
    campus: '',
  });
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  const filterCompanies = data.filter((n) => n.active);
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = data.map((n) => n.companyEmail);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  const handleClick = (event, email) => {
    const selectedIndex = selected.indexOf(email);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, email);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }

    setSelected(newSelected);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);
  const onChangeSelect = (e) => {
    const {target} = e;
    const {name} = target;
    const {value} = target;
    const emails = [];
    const promise = Promise.all(
      data.map((us) => {
        if (us.campusSegment === value) {
          emails.push(us.companyEmail);
        }
      })
    );
    promise.then(() => {
      // console.log(emails);
      setSelected(emails);
    });
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <div className={classes.root} style={{ backgroundColor: 'white' }}>
      <div className={classes.selectArea}>
        <div className={classes.selectContainer}>
          <label className={classes.selectCarrer}>Filtrar por campus</label>
          <select className={classes.selectCarrer} value={state.campus} onChange={onChangeSelect} name="campus">
            <option value="">Selecciona una</option>
            {platform.platformCampus.map((c) => {
              return (
                <option key={c} value={c}>
                  {c}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      {state.campus !== '' ? (
        <Paper className={classes.paper} elevation={0}>
          <div className={classes.selectArea}>
            <p className={classes.message}>
              Se enviará el mail a todas las empresas pertenecientes al campus seleccionado
            </p>
          </div>
          <div className={classes.buttonContainer}>
            <button type="button" className={classes.ButtonSend} onClick={() => sendEmail(selected)}>
              Enviar correo
            </button>
          </div>
        </Paper>
      ) : (
        <Paper className={classes.paper} elevation={0}>
          <TableContainer>
            <Table className={classes.table} aria-labelledby="tableTitle" size="medium" aria-label="enhanced table">
              <EnhancedTableHead
                classes={classes}
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={data.length}
              />
              <TableBody>
                {stableSort(data, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const isItemSelected = isSelected(row.companyEmail);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    if (row.active) {
                      return (
                        <TableRow
                          hover
                          onClick={(event) => handleClick(event, row.companyEmail)}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.companyEmail}
                          selected={isItemSelected}>
                          <TableCell padding="checkbox">
                            <Checkbox checked={isItemSelected} inputProps={{ 'aria-labelledby': labelId }} />
                          </TableCell>
                          <TableCell
                            className={classes.textSize}
                            component="th"
                            id={labelId}
                            scope="row"
                            padding="none">
                            {`${row.companyName}`}
                          </TableCell>
                          <TableCell
                            className={classes.textSize}
                            component="th"
                            id={labelId}
                            scope="row"
                            padding="none">
                            {`${row.companyEmail}`}
                          </TableCell>
                        </TableRow>
                      );
                    }
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            className={classes.textSize}
            rowsPerPageOptions={[5, 10, 20]}
            component="div"
            count={filterCompanies.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            labelRowsPerPage={<span style={{ fontSize: '1rem' }}>Usuarios por pagina</span>}
          />
          <div className={classes.ButtonContainer}>
            <button type="button" className={classes.ButtonSend} onClick={() => sendEmail(selected)}>
              Enviar correo
            </button>
          </div>
        </Paper>
      )}
    </div>
  );
};
